export function NonSortableColumnHeader({
  label, minWidth,
}: {
  label: string;
  minWidth?: string;
}) {
  return (
    <th
      scope="col"
      className={minWidth ? `min-w-[${minWidth}]` : ''}
    >
      <span className="px-5 py-2.5 text-start w-full flex items-center gap-x-1 text-sm font-normal text-onsurface opacity-60">
        {label}
      </span>
    </th>
  );
}
